import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/AsesmenMedisIgd";
import { isEmpty } from "lodash";

interface Data {
  id: number;
  pasien_rm: number;
  register_id: number;
  content: any;
  image: string;
  pemeriksaan_image_url: string;
  created_at: string;
  updated_at: string;
}

@Module({ dynamic: true, namespaced: true, store, name: "asesmen-medis-igd" })
class AsesmenMedisIgdStore extends VuexModule {
  loading = false;
  asesmen: Data = null;

  @Mutation
  SET_ASESMEN(val) {
    this.asesmen = val;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  RESET_STORE() {
    this.asesmen = null;
  }

  @Action({ rawError: true })
  async getByRegister(registerId): Promise<void> {
    this.SET_LOADING(true);

    const response = await Service.getByRegister(registerId).finally(() => {
      this.SET_LOADING(false);
    });

    const data = isEmpty(response.data) ? null : response.data;

    this.SET_ASESMEN(data);
  }

  @Action({ rawError: true })
  reset(): void {
    this.RESET_STORE();
  }
}

export default getModule(AsesmenMedisIgdStore);
